import React from 'react';
import { SearchItem, SearchItemType } from '../../SearchItem';
import { ClearButton, Label, QueriesContainer, SearchSubHeader } from './RecentSearchBody.styles';
export function RecentSearchBody(_ref) {
  let {
    queries,
    onSelect,
    onClearAll
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchSubHeader, null, /*#__PURE__*/React.createElement(Label, null, "Your past searches"), /*#__PURE__*/React.createElement(ClearButton, {
    type: "button",
    role: "button",
    onClick: onClearAll
  }, "Clear past searches")), /*#__PURE__*/React.createElement(QueriesContainer, null, queries.map(query => /*#__PURE__*/React.createElement(SearchItem, {
    key: query,
    type: SearchItemType.RECENT,
    text: query,
    onClick: () => onSelect(query)
  }))));
}